<div style="border: 1px dashed">
  <form (ngSubmit)="templateFormSubmit()" #tForm="ngForm">
    <app-layout-container fluid>
      <app-layout-row>
        <app-layout-column [width]="4">
          <span>Template form</span>
        </app-layout-column>
      </app-layout-row>
      <app-layout-row>
        <app-layout-column [width]="4" offset="4">
          <!-- <app-textbox decorator [ngModel]="myData().name" name="name" caption="Name" required maxlength="10" pattern="[a-zA-Z ]*" [calculateValidationText]="getValidationText"
            infoText="Your full name"></app-textbox> -->
          <app-textbox decorator [ngModel]="myData().name" name="name" caption="Name" required maxlength="10" pattern="[a-zA-Z ]*" [calculateValidationText]="getValidationText"
            infoText="Your full name"></app-textbox>
        </app-layout-column>
      </app-layout-row>
      <app-layout-row>
        <app-layout-column [width]="4" offset="4">
          <app-textbox decorator #email [ngModel]="myData().email" name="email" caption="Email" email [appConditionalValidator]="newsletterValidators" [condition]="newsletterCondition"></app-textbox>
        </app-layout-column>
      </app-layout-row>
      <app-layout-row>
        <app-layout-column [width]="1" offset="4">
          <app-textbox decorator [ngModel]="myData().zip" name="zip" caption="Zip" (valueChange)="updateValidation([city])"></app-textbox>
        </app-layout-column>
        <app-layout-column [width]="3">
          <app-textbox decorator #city [ngModel]="myData().city" name="city" caption="City" [appConditionalValidator]="zipValidators" [condition]="zipCondition"></app-textbox>
        </app-layout-column>
      </app-layout-row>
      <app-layout-row>
        <app-layout-column [width]="2" offset="4">
          <app-password decorator [ngModel]="myData().passwordHash" name="passwordHash" caption="Password (Hashed)" section="templateHash" mode="hash" infoText="This is a hash based password"></app-password>
        </app-layout-column>
        <app-layout-column [width]="2">
          <app-password decorator [ngModel]="myData().passwordSecret" name="passwordSecret" caption="Password (Secret)" section="templateSecret" mode="secret"
            infoText="This is a secret based password"></app-password>
        </app-layout-column>
      </app-layout-row>
      <app-layout-row>
        <app-layout-column [width]="4" offset="4">
          <app-xpath decorator [ngModel]="myData().xpath" name="xpath" caption="XPath" required maxlength="20" infoText="What' you think?"></app-xpath>
        </app-layout-column>
      </app-layout-row>
      <app-layout-row>
        <app-layout-column [width]="2" offset="4">
          <app-singleselectbox decorator name="backgroundColor" caption="Background color" infoText="Please pick a color" [ngModel]="myData().backgroundColor" [dataSource]="colors()" valueExpr="id"
            displayExpr="name"></app-singleselectbox>
        </app-layout-column>
        <app-layout-column [width]="2">
          <app-singleselectbox decorator name="foregroundColor" caption="Foreground color" infoText="Please pick a color" [ngModel]="myData().foregroundColor" [dataSource]="colors()" valueExpr="id"
            displayExpr="name" required></app-singleselectbox>
        </app-layout-column>
      </app-layout-row>
      <app-layout-row>
        <app-layout-column [width]="2" offset="4">
          <app-multiselectbox decorator name="moreColors" caption="More colors" infoText="Please pick some colors" [ngModel]="myData().moreColors" [dataSource]="colors()" valueExpr="id"
            displayExpr="name"></app-multiselectbox>
        </app-layout-column>
        <app-layout-column [width]="2">
          <app-multiselectbox decorator name="otherColors" caption="Other colors" infoText="Please pick some colors" [ngModel]="myData().otherColors" [dataSource]="colors()" valueExpr="id" displayExpr="name"
            required></app-multiselectbox>
        </app-layout-column>
      </app-layout-row>
      <app-layout-row>
        <app-layout-column [width]="2" offset="4">
          <app-checkbox decorator="right-side" name="receiveNewsletter" caption="Receive newsletter" [ngModel]="myData().receiveNewsletter" (valueChange)="updateValidation([email])"></app-checkbox>
        </app-layout-column>
        <app-layout-column [width]="2">
          <app-datetimebox datetime decorator name="datetime" [ngModel]="myData().datetime" caption="Date and time" minDate="2024-05-01T08:00:00+02:00" maxDate="2024-05-15T16:30:00+02:00"
            infoText="Specify a date and a time" required></app-datetimebox>
        </app-layout-column>
      </app-layout-row>
      <app-layout-row>
        <app-layout-column [width]="2" offset="4">
          <app-datetimebox date decorator name="date" [ngModel]="myData().date" caption="Date" minDate="2024-05-01" infoText="Specify just a date and no time"></app-datetimebox>
        </app-layout-column>
        <app-layout-column [width]="2">
          <app-datetimebox time decorator name="time" [ngModel]="myData().time" caption="Time" timeInterval="10" infoText="Specify just a time and no date"></app-datetimebox>
        </app-layout-column>
      </app-layout-row>

      <app-layout-row>
        <app-layout-column [width]="2" offset="4">
          @if (tForm.enabled) {
          <app-layout-row margin="">
            <app-layout-column [width]="4">
              <app-button primary width="100%" submit [disabled]="tForm.invalid">Save</app-button>
            </app-layout-column>
            <app-layout-column [width]="4">
              <app-button secondary width="100%" (buttonClick)="templateFormCancel()">Cancel</app-button>
            </app-layout-column>
            <app-layout-column [width]="4">
              <app-button tertiery width="100%" (buttonClick)="templateFormClear()">Clear</app-button>
            </app-layout-column>
          </app-layout-row>
          } @else {
          <app-button primary width="100%" (buttonClick)="templateFormEdit()">Edit</app-button>
          }
        </app-layout-column>
        <app-layout-column [width]="2">
          <app-button secondary width="100%" (buttonClick)="refresh()" [disabled]="!tForm.disabled">Reload</app-button>
        </app-layout-column>
      </app-layout-row>

      <app-layout-row>
        <app-layout-column [width]="4" offset="4">
          <div>Form: {{tForm.value | json}}</div>
          <br />
          <div>Data: {{myData() | json}}</div>
        </app-layout-column>
      </app-layout-row>
    </app-layout-container>
  </form>
</div>
